import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';
import { HelpIcon } from './HelpIcon';

interface Props extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  padded?: boolean;
}

export const Card = forwardRef<HTMLDivElement, Props>(function Card(
  { interactive, padded = true, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-md border border-ink-200 bg-paper',
        padded && 'p-6',
        interactive && 'transition-shadow hover:shadow-elev-2 hover:-translate-y-px duration-150',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
});

export function CardHeader({
  title,
  description,
  action,
  helpKey,
  className,
}: {
  title: React.ReactNode;
  description?: string;
  action?: React.ReactNode;
  /** Tooltip-Inventory-Key — rendert ein HelpIcon rechts neben dem Titel. */
  helpKey?: string;
  className?: string;
}) {
  return (
    <div className={cn('mb-4 flex items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <h3 className="text-base font-semibold text-ink-900">{title}</h3>
          {helpKey ? <HelpIcon helpKey={helpKey} /> : null}
        </div>
        {description ? <p className="mt-0.5 text-sm text-ink-500">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
